import {
  Space,
  Avatar,
  Tag,
  Switch,
  Button,
  Select,
  Dropdown,
  Tooltip,
  Popconfirm,
  InputNumber,
  Flex,
} from "antd";
import {
  EyeOutlined,
  DeleteOutlined,
  ClockCircleOutlined,
  MobileOutlined,
  ExportOutlined,
  LoadingOutlined,
  FormOutlined,
  ReloadOutlined,
  WarningOutlined,
  MoreOutlined,
  InfoCircleOutlined,
  QrcodeOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { t } from "i18next";
import {
  tagsBageStatus,
  tagsColorBalance,
  tagsTypeBage,
} from "../../helpers/tagsBage";
import moment from "moment";
import {
  processPollingStatus,
  removeBackslashes,
  formatPromptPayNumber,
  convertMsToMinutes,
  confirmSwal,
} from "../../utils";
import { CopyTextToClipboard } from "../../helpers/copy";
import { FormatTimeAgo } from "../../helpers/formatTimeAgo";
import { CheckAdminType } from "../../helpers/checkPermission";
import deposit from "../../assets/images/icon/wallet-in.png";
import Withdraw from "../../assets/images/icon/wallet-out.png";
import verified from "../../assets/images/icon/wallet-verify-count.png";
import { iconTypeBank } from "../../screens/Bank/components/iconBank";
import config from "../../config/app.config";
import { TypeOptions } from "../../Data/FormConfig ";

/**
 * @param {function} handleChangeStatusBank
 * @param {boolean | number} switchLoadding
 * @param {boolean} showDrawer
 * @param {boolean} showPromiseConfirm
 * @param {boolean} showPromiseConfirmStatusBank
 * @param {function} handleDeleteAccounts
 * @param {function} getBalance
 * @param {boolean} loadingBankAccounts
 * @param {boolean | number} switchTypePayLoadding
 * @param {('topLeft' | 'bottomRight')} dropdownPlacement
 * @param {function} handleGenDevice
 */

// Current
export const ColumnsCurrent = (
  handleChangeStatusBank,
  switchLoadding,
  showDrawer,
  showPromiseConfirm,
  showPromiseConfirmStatusBank,
  handleDeleteAccounts,
  getBalance,
  switchTypePayLoadding,
  dropdownPlacement,
  handleGenDevice,
  setTimeinterval,
  loadingtimeinterval,
  history,
  disabled,
  isNextMinute,
  setTransFee,
  loadingSetTransFee,
  showPopconfirm,
  openPopconfirm,
  handleCancelPopconfirm,
  valueSetTransFee,
  onChangeSetTransFee,
  disabledInput,
  handleEditData,
  selectTypeLoadding,
  currentLanguage,
  resProfileAdmin,
  canAddBank,
  canDelBank,
  canEditAdvancedBank,
  canEditBank,
  canDetailsBank,
  canChangStatusBank,
  canSetIntervalBank,
  canOn_OffBank,
  canSetFeeBank,
  canChangTypeBank,
  enabled_verify_hub,
  onChangeEnabled,
  handleLoginQr,
  handleLogoutQr
) => [
    // #ID
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (id, record, index) => {
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canDetailsBank;

        return <>
          <span
            className={`hover text-center`}
            onClick={() => {
              if (!accessible) {
                alert("!" + t("You don't have permission to view details"));
                return;
              }
              showDrawer(record)
            }}
            
            style={{ cursor: "pointer", color: record?.status_bank === "Active" ? "#007bff" : "inherit" }}
          >
            <u title={t("Details")}>#{id}</u>
          </span>
        </>
      },
    },

    // Bank Account
    {
      title: t("Bank Account"),
      dataIndex: "bank",
      key: "bank",
      render: (bank, record) => {
        const imgUrl =
          bank?.imageUrl || `https://img2.pic.in.th/pic/noimage4x4.th.jpeg`;
        // const txtCopy = `${bank?.bank_id} - ${record?.accountNumber} - ${record?.accountName}`;
        return (
          <div
          >
            <Avatar size={22} src={imgUrl} /> -{" "}
            <span title="Copy Account number" className="hover" style={{ fontWeight: "600", cursor: "copy" }} onClick={() => CopyTextToClipboard(record?.accountNumber)}>
              {formatPromptPayNumber(record?.accountNumber)}
            </span>
            <br />
            <span title="Copy Name" className="mt-3 hover" style={{ cursor: "copy" }} onClick={() => CopyTextToClipboard(record?.accountName)}>{record?.accountName}</span>
          </div>
        );
      },
    },

    // account type
    {
      title: t("account type"),
      dataIndex: "accountType",
      key: "accountType",
      // sorter: (a, b) => a.accountType.length - b.accountType.length,
      sorter: false,

      render: (accountType, record) => {
        let icon = iconTypeBank(accountType);
        let PendingDevice = record?.status_bank === "PendingDevice";
        let checkBank = record?.bank?.bank_id;
        const options = TypeOptions(t, checkBank);

        let currentOption = options.filter(option => !option.disabled);

        const sharedProps = {
          prefix: <><Avatar shape="square" size={18} src={icon}></Avatar></>
        };

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canChangTypeBank;

        return (
          <Space
            className="text-truncate"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            {!accessible || PendingDevice ? <Tag color={tagsTypeBage(accountType)}>{t(accountType)}</Tag> : <Select
              {...sharedProps}
              value={accountType}
              popupMatchSelectWidth={true}
              dropdownMatchSelectWidth={true}
              loading={selectTypeLoadding === record?.id}
              disabled={selectTypeLoadding === record?.id}
              size="small"
              style={{ width: currentLanguage === "en" ? 127 : 115 }}
              onChange={(e) => {
                if (!accessible) return alert("!" + t("You don't have permission to change account type"));
                showPromiseConfirm(e, record)
              }}

              // ใช้ optionRender เพื่อกำหนดหน้าตาของแต่ละแถวใน Dropdown
              optionRender={(option) => (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {option?.data?.icon}
                  <span>{option.data.label}</span>
                </div>
              )}

              options={currentOption}
            />}


          </Space>
        );
      },
    },
    // Channel
    {
      title: t("Channel"),
      dataIndex: "channel",
      key: "channel",
      render: (record) => {
        return (
          <div
            className="text-truncate"
            style={{ fontSize: "12px", width: 73 }}
            title={record}
          >
            <em style={{ color: "#888888b4" }}>
              <small>{record}</small>
            </em>
          </div>
        );
      },
    },

    // Balance
    {
      title: t("Balance"),
      key: "balance",
      dataIndex: "balance",
      render: (_, record) => {
        let spinner = switchLoadding === record?.id;
        let status_bank =
          record?.status_bank === "Active" || record?.status_bank === "Inactive";
        let balance = record?.balance
          ? `${Intl.NumberFormat().format(record?.balance)}`
          : "-";
        return (
          <code
            style={{
              textTransform: "lowercase",
              color: tagsColorBalance(record?.balance),
              fontWeight: "600",
            }}
          >
            {spinner ? (
              <>
                <LoadingOutlined style={{ color: "rgba(0, 0, 0, 0.41)" }} />{" "}
                <small style={{ fontSize: "13px", color: "rgba(0, 0, 0, 0.41)" }}>
                  {"loading..."}
                </small>
              </>
            ) : (
              <>
                {balance}{" "}
                {disabled === record?.id ? (
                  <Tooltip title={isNextMinute || ""}>
                    <ReloadOutlined
                      style={{
                        color: "#828482",
                        cursor: "help",
                      }}
                      onClick={() => alert(isNextMinute)}
                    />
                  </Tooltip>
                ) : (
                  <>
                    {status_bank && (
                      <ReloadOutlined
                        style={{
                          cursor: "pointer",
                          opacity: 0.5
                        }}
                        className="icon-hover"
                        title="Check balance"
                        onClick={() => getBalance(record?.id)}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </code>
        );
      },
      // sorter: (a, b) => a.balance.length - b.balance.length,
      sorter: false,
    },

    // transFee
    {
      title: t("fee"),
      dataIndex: "transFee",
      key: "transFee",
      render: (transFee, record) => {
        let view = CheckAdminType("setTransFee");
        let spinIcon = loadingSetTransFee === record?.id;
        let openLoading = openPopconfirm === record?.id;

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canSetFeeBank;

        const sharedProps = {
          mode: "spinner",
          min: `${record?.minimumFee}`,
          max: `100`,
          defaultValue: transFee,
          onChange: (e) => onChangeSetTransFee(e),
          style: { width: 150 },
        };
        let balance =
          transFee >= 0 ? (
            `${Intl.NumberFormat().format(transFee)}`
          ) : (
            <>
              <em style={{ fontSize: 10, color: "#888" }}>{t("No data")}</em>{" "}
            </>
          );
        return (
          <code style={{ color: "#0000008a" }}>
            {transFee >= 0 ? (
              <>
                <Popconfirm
                  title={t("setting")}
                  description={
                    <Flex vertical gap="small">
                      <label style={{ fontSize: 12 }}>
                        {t("fee")} <br />
                        <InputNumber
                          {...sharedProps}
                          addonAfter="%"
                          step="0.1"
                          stringMode
                          disabled={spinIcon}
                          className="mt-1"
                          controls={false}
                        />
                      </label>

                      <p style={{ fontSize: 12, color: "#c54343" }}>
                        <>
                          *{t("minimumFee", { minimumFee: record?.minimumFee })}
                        </>
                      </p>
                    </Flex>
                  }
                  arrow={true}
                  maskClosable={true}
                  open={openLoading}
                  onConfirm={() => setTransFee(record, valueSetTransFee)}
                  icon={null}
                  okButtonProps={{
                    loading: spinIcon,
                    disabled: disabledInput || valueSetTransFee <= transFee,
                  }}
                  onCancel={handleCancelPopconfirm}
                  okText={t("Confirm")}
                  cancelText={t("Cancel")}
                >
                  {!openLoading ? (
                    <>
                      {balance}{" "}
                      {accessible && (<FormOutlined
                        title={t("edit")}
                        className="icon-hover"
                        style={{ cursor: "pointer", display: view ? "" : "none", opacity: 0.5 }}
                        onClick={() => {
                          if (!accessible) return alert("!" + t("You don't have permission to set fee"));
                          showPopconfirm(record?.id)
                        }}
                      />)}

                    </>
                  ) : (
                    <>
                      <LoadingOutlined />
                    </>
                  )}
                </Popconfirm>{" "}
              </>
            ) : (
              <em style={{ color: "#888" }}>
                <small>{t("No data")}</small>
              </em>
            )}{" "}
          </code>
        );
      },
      // sorter: (a, b) => a.limit_Left.length - b.limit_Left.length,
      sorter: false,
    },

    // Status
    {
      title: t("Status"),
      key: "status_bank",
      dataIndex: "status_bank",
      render: (status, record) => {
        let ActiveInactive = status === "Active" || status === "Inactive";

        let accountType = record?.accountType === "verifying_account";
        let PendingDevice = status === "PendingDevice";

        const isGsbBank = record?.bank?.bank_id === "gsb"; // เช็คว่าเป็นธนาคารออมสินหรือไม่ ถ้าใช่ (true) ไม่ให้แสดงปุ่ม Gen Device

        const canAdd = canAddBank;

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canOn_OffBank;

        return (
          <span>
            {ActiveInactive && accessible ? (
              <Switch
                onChange={async (e) => {
                  if (!accessible) {
                    alert("!" + t("You don't have permission to on/off account"));
                    return;
                  }
                  if (accountType && enabled_verify_hub === true) {
                    let confirm = await confirmSwal("question", t(`บริการตรวจสอบบัญชีลูกค้าของระบบ {{appName}} เปิดใช้งานอยู่ เปิดใช้งานและเปิดใช้งานตรวจสอบลูกค้าของร้านค้า`, { appName: config.web_name }))
                    if (confirm) {
                      onChangeEnabled(false);
                      handleChangeStatusBank(e, record)
                    }
                    return;
                  } else {
                    handleChangeStatusBank(e, record)
                  }
                }}
                checkedChildren={<>{t("enabled")}</>}
                size="small"
                unCheckedChildren={<>{t("disabled")}</>}
                loading={record.id === switchLoadding}
                checked={status === "Active"}
                title={status === "Active" ? t("disabled") + '?' : t("enabled") + '?'}
              />
            ) : PendingDevice && !isGsbBank && canAdd ? (
              <Space wrap style={{ columnGap: 0 }}>
                <Tag color={tagsBageStatus(status)}>{t(status)}</Tag>
                <Tooltip
                  className="d-none"
                  title={
                    <>
                      {t("เรียนรู้เพิ่มเติม")}{" "}
                      <ExportOutlined
                        onClick={() => history.push("/KrungthaiBusinessGuide")}
                      />
                    </>
                  }
                >
                  <InfoCircleOutlined
                    className="hover"
                    onClick={() => history.push("/KrungthaiBusinessGuide")}
                    style={{ fontSize: 16, cursor: "pointer" }}
                  />
                </Tooltip>
              </Space>
            ) : (
              <Tag color={tagsBageStatus(status)}>{t(status)}</Tag>
            )}
          </span>
        );
      },
    },

    // timeinterval
    {
      title: t("timeinterval"),

      render: (item) => {
        let minutes = convertMsToMinutes(item?.timeinterval_ms);
        let type = item?.accountType === "deposit";

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canSetIntervalBank;
        const iconPrefix = <ClockCircleOutlined style={{ color: "#888" }} />;
        return (
          <span>
            {" "}
            <Tooltip
              placement="right"
              color={type ? "blue" : "red"}
              title={type ? `${t("Caution")}` : `${t("unCaution")}`}
            >
              {accessible && type ? (

                <Select
                  size="small"
                  style={{ flex: 1, color: "#888", fontSize: 12, display: `${type ? "block" : "none"}` }}
                  prefix={iconPrefix}
                  onChange={(e) => {
                    if (!accessible) {
                      alert("!" + t("You don't have permission to set time interval"));
                      return;
                    }
                    setTimeinterval(e, item)
                  }}
                  variant={type ? "outlined" : "filled"}
                  loading={loadingtimeinterval === item?.id}
                  disabled={loadingtimeinterval === item?.id || !type}
                  value={`${minutes} ${t("minutes")}`}
                  options={[
                    {
                      label: <span>{t("Select")}</span>,
                      options: [
                        { value: "1", label: `1 ${t("minutes")}` },
                        { value: "1.3", label: `1.3 ${t("minutes")}` },
                        { value: "2", label: `2 ${t("minutes")}` },
                        { value: "3", label: `3 ${t("minutes")}` },
                        { value: "4", label: `4 ${t("minutes")}` },
                        { value: "5", label: `5 ${t("minutes")}` },
                      ],
                    },
                  ]}
                />

              ) : <>{type ? <>{iconPrefix} {`${minutes} ${t("minutes")}`}</> : null}</>}
            </Tooltip>
          </span>
        );
      },
    },

    // /createdAt updatedAt
    {
      title: (
        <>
          {t("createdAt")} <br />{" "}
          <span style={{ fontWeight: "500" }}>{t("updatedAt")}</span>
        </>
      ),

      render: (item) => (
        <span>
          {" "}
          <span title={moment(item?.created_at).format("YYYY-MM-DD HH:mm:ss")}>
            {FormatTimeAgo(item?.created_at)}
          </span>{" "}
          <br />
          <span
            title={moment(item?.updated_at).format("YYYY-MM-DD HH:mm:ss")}
            style={{ fontWeight: "500" }}
            className="d-block"
          >
            <code style={{ color: "rgb(90 90 90)" }}>
              {FormatTimeAgo(item?.updated_at)}
            </code>
          </span>
        </span>
      ),
    },

    // note
    {
      title: t("note"),
      dataIndex: "note",
      key: "note",
      render: (note) => {
        return (
          <div
            className="text-wrap"
            style={{ fontSize: "11px", width: note ? 100 : 80 }}
          >
            {note ? (
              note
            ) : (
              <em style={{ color: "#888888b4" }}>
                <small>{t("No data")}</small>
              </em>
            )}
          </div>
        );
      },
    },

    // Action Column
    {
      title: <span className="text-truncate">{t("Action")}</span>,
      key: "action",
      render: (_, record) => {
        // --- 1. State & Permissions Checks ---
        const isPendingDevice = record?.status_bank === "PendingDevice";
        const isLoginQR = record?.status_bank === "LoginQR";
        const isVerifyIp = record?.is_verify_ip === true;
        const isDeviceId = record?.deviceId === null;
        const isGsbBank = record?.bank?.bank_id === "gsb";
        const isKtbBank = record?.bank?.bank_id === "ktb";
        const isLogout = record?.channel === "k-biz-qr" && !isLoginQR; // เช็คว่าเป็นช่องทาง kbiz-qr และไม่ใช่สถานะ LoginQR

        const canDetails = canDetailsBank;
        const canEdit = canEditBank || canEditAdvancedBank;
        const canChange = canChangStatusBank; // แก้ตัวสะกด
        const canDel = canDelBank;
        const canAdd = canAddBank; // แนะนำให้แยกสิทธิ์ให้ชัดเจน

        // --- 2. Build Menu Items (Normal Case) ---
        const menuItems = [
          canDetails && { key: "Details", icon: <EyeOutlined />, label: t("Details"), onClick: () => showDrawer(record) },
          canEdit && { key: "Edit", icon: <FormOutlined />, label: t("edit"), onClick: () => handleEditData(record) },
          canChange && { key: "Problems", icon: <WarningOutlined />, label: t("Problems"), onClick: () => showPromiseConfirmStatusBank(record) },
          isLogout && { key: "Logout-QR", icon: <LogoutOutlined />, label: t("Logout-QR"), onClick: () => handleLogoutQr(record) },
          canDel && { key: "Delete", icon: <DeleteOutlined />, label: t("Delete"), danger: true, onClick: () => handleDeleteAccounts(record) },
        ].filter(Boolean); // กรองค่าที่เป็น false/null ออก

        // --- 3. Build Verify Items (GSB Case) ---
        const verifyItems = [];


        if (canAdd && isVerifyIp && isGsbBank) {
          verifyItems.push({
            key: 'verify-maker',
            label: t("Verify maker"),
            icon: <i className='bx bx-user-plus fs-18'></i>,
            onClick: () => handleGenDevice("Verify Maker", record)
          });
        }
        if (canAdd && (isDeviceId && isGsbBank)) {
          verifyItems.push({
            key: 'verify-auth',
            label: t("Verify Authorize"),
            icon: <i className='bx bx-user-check fs-18'></i>,
            onClick: () => handleGenDevice("Verify Authorizer", record),
          });
        }
        if (isKtbBank) {
          verifyItems.push({
            key: "genDevice",
            icon: <MobileOutlined />,
            label: t("genDevice"),
            onClick: () => handleGenDevice("genDevice", record)
          });
        }
        if (isLoginQR) {
          verifyItems.push({
            key: "loginqr",
            icon: <QrcodeOutlined />,
            label: t("Login-QR"),
            onClick: () => handleLoginQr(record)
          });
        }
        if (isLoginQR && canChange) {
          verifyItems.push({
            key: "Problems2",
            icon: <WarningOutlined />,
            label: t("Problems"),
            onClick: () => showPromiseConfirmStatusBank(record)
          });
        }
        if (isLoginQR && canChange) {
          verifyItems.push({
            key: "Edit2",
            icon: <FormOutlined />,
            label: t("edit"),
            onClick: () => handleEditData(record)
          });
        }
        if (canDel) {
          verifyItems.push({
            key: "Delete",
            icon: <DeleteOutlined />,
            label: t("Delete"),
            danger: true,
            onClick: () => handleDeleteAccounts(record)
          });
        }


        return (
          <Space size="middle">
            {isPendingDevice || isLoginQR ? (
              <div style={{ display: 'flex', gap: '8px' }}>

                {/* GSB Verify Dropdown */}
                {verifyItems.length > 0 && (
                  <Dropdown
                    trigger={["click"]}
                    placement={dropdownPlacement || "bottomRight"}
                    arrow={true}
                    menu={{ items: verifyItems }}
                  >
                    <Button shape="circle" icon={<MoreOutlined />} style={{ color: "#5A5A5A" }} />
                  </Dropdown>
                )}
              </div>
            ) : (
              /* Normal Case */
              menuItems.length > 0 && (
                <Dropdown
                  trigger={["click"]}
                  placement={dropdownPlacement || "bottomRight"}
                  menu={{ items: menuItems }}
                  arrow={true}
                >
                  <Button shape="circle" icon={<MoreOutlined style={{ color: "#5A5A5A" }} />} />
                </Dropdown>
              )
            )}
          </Space>
        );
      },
    }

  ];

// Verify
export const ColumnsVerify = (
  handleChangeStatusBank,
  showPromiseConfirm,
  handleDeleteAccounts,
  switchLoadding,
  showDrawer,
  dropdownPlacement,
  tableParams,
  disabled,
  isNextMinute,
  getBalance,
  handleEditData,
  selectTypeLoadding,
  currentLanguage,
  resProfileAdmin,
  canDelBank,
  canEditAdvancedBank,
  canEditBank,
  canDetailsBank,
  canOn_OffBank,
  canChangTypeBank,
  enabled_verify_hub,
  onChangeEnabled
) => [

    // #ID
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (id, record, index) => {
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canDetailsBank;

        return <>
          <span
            className={`hover text-center`}
            onClick={() => {
              if (!accessible) {
                alert("!" + t("You don't have permission to view details"));
                return;
              }
              showDrawer(record)
            }}
            title="View details"
            style={{ cursor: "pointer", color: record?.status_bank === "Active" ? "#007bff" : "inherit" }}
          >
            <u>#{id}</u>
          </span>
        </>
      },
    },

    // Bank
    {
      title: t("Bank"),
      dataIndex: "bank",
      key: "bank",
      render: (bank) => {
        const imgUrl =
          bank.imageUrl || `https://img2.pic.in.th/pic/noimage4x4.th.jpeg`;
        return (
          <>
            <Space direction="vertical">
              <Avatar size={"default"} src={imgUrl} />
            </Space>
          </>
        );
      },
    },

    // Account Name
    {
      title: t("Account Name"),
      dataIndex: "accountName",
      key: "accountName",
      render: (accountName) => (
        <span className="text-truncate hover" onClick={() => CopyTextToClipboard(accountName)} style={{ maxWidth: "60px", cursor: "copy" }}>
          {accountName}
        </span>
      ),
    },

    // Account Number
    {
      title: t("Account No."),
      dataIndex: "accountNumber",
      key: "accountNumber",
      render: (accountNumber) => (
        <span style={{ maxWidth: "60px" }} className="text-truncate">
          {accountNumber < 0 ? (
            <em style={{ color: "#888" }}>
              <small>No data</small>
            </em>
          ) : (
            <span style={{ cursor: "copy" }} className="hover" onClick={() => CopyTextToClipboard(accountNumber)}>{accountNumber}</span>
          )}
        </span>
      ),
    },

    // account type
    {
      title: t("account type"),
      dataIndex: "accountType",
      key: "accountType",
      // sorter: (a, b) => a.accountType.length - b.accountType.length,
      sorter: false,

      render: (accountType, record) => {
        let icon = iconTypeBank(accountType);
        let PendingDevice = record?.status_bank === "PendingDevice";
        const options = [

          {
            value: "withdrawal",
            label: t("Withdrawal"),
            icon: <Avatar shape="square" size={17} src={Withdraw} />,
            disabled: record?.bank?.bank_id === "ttb",
            show: accountType !== "withdrawal",
            title: t("Withdrawal")
          },
          {
            value: "deposit",
            label: t("Deposit"),
            icon: <Avatar shape="square" size={17} src={deposit} />,
            disabled: record?.bank?.bank_id === "gsb",
            show: accountType !== "deposit",
            title: t("Deposit")

          },
          {
            value: "verifying_account",
            label: t("Verifying"),
            icon: <Avatar shape="square" size={17} src={verified} />,
            disabled: !["ktb", "scb"].includes(record?.bank?.bank_id),
            show: accountType !== "verifying_account",
            title: t("verifying_account")

          },
        ];
        let currentOption = options.filter(option => !option.disabled);

        const sharedProps = {
          prefix: <><Avatar shape="square" size={18} src={icon}></Avatar></>
        };

        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canChangTypeBank;

        return (
          <Space
            className="text-truncate"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            {!accessible || PendingDevice ? <Tag color={tagsTypeBage(accountType)}>{t(accountType)}</Tag> : <Select
              {...sharedProps}
              value={accountType}
              popupMatchSelectWidth={true}
              dropdownMatchSelectWidth={true}
              loading={selectTypeLoadding === record?.id}
              disabled={selectTypeLoadding === record?.id}
              size="small"
              style={{ width: currentLanguage === "en" ? 127 : 115 }}
              onChange={(e) => {
                if (!accessible) return alert("!" + t("You don't have permission to change account type"));
                showPromiseConfirm(e, record)
              }}

              // ใช้ optionRender เพื่อกำหนดหน้าตาของแต่ละแถวใน Dropdown
              optionRender={(option) => (
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  {option?.data?.icon}
                  <span>{option.data.label}</span>
                </div>
              )}

              options={currentOption}
            />}


          </Space>
        );
      },
    },

    // Balance
    {
      title: t("Balance"),
      dataIndex: "balance",
      key: "balance",
      render: (_, record) => {
        let spinner = switchLoadding === record?.id;
        let balance = record?.balance
          ? `${Intl.NumberFormat().format(record?.balance)}`
          : "-";
        let status_bank =
          record?.status_bank === "Active" || record?.status_bank === "Inactive";
        return (
          <code
            style={{
              textTransform: "lowercase",
              color: tagsColorBalance(record?.balance),
              fontWeight: "600",
            }}
          >
            {spinner ? (
              <>
                <LoadingOutlined style={{ color: "#888" }} />{" "}
                <small style={{ fontSize: "13px", color: "#888" }}>
                  {"loading..."}
                </small>
              </>
            ) : (
              <>
                {balance}{" "}
                {disabled === record?.id ? (
                  <Tooltip title={isNextMinute || ""}>
                    <ReloadOutlined
                      style={{
                        color: "#828482",
                        cursor: "help",
                      }}
                      onClick={() => alert(isNextMinute)}
                    />
                  </Tooltip>
                ) : (
                  <>
                    {status_bank && (
                      <ReloadOutlined
                        style={{
                          cursor: "pointer",
                          opacity: 0.5
                        }}
                        className="icon-hover"
                        title="Check balance"
                        onClick={() => getBalance(record?.id)}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </code>
        );
      },
    },

    // Status
    {
      title: t("Status"),
      render: (item) => {
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canOn_OffBank;

        return <span>
          {" "}
          {(item.status_bank === "Active" || item.status_bank === "Inactive") && accessible ? (
            <Switch
              onChange={async (e) => {
                if (!accessible) {
                  alert("!" + t("You don't have permission to on/off account"));
                  return;
                }
                if (enabled_verify_hub === true) {
                  let confirm = await confirmSwal("question", t(`บริการตรวจสอบบัญชีลูกค้าของระบบ {{appName}} เปิดใช้งานอยู่ เปิดใช้งานและเปิดใช้งานตรวจสอบลูกค้าของร้านค้า`, { appName: config.web_name }))
                  if (confirm) {
                    onChangeEnabled(false);
                    handleChangeStatusBank(e, item)
                  }
                  return;
                } else {
                  handleChangeStatusBank(e, item)
                }

              }}
              checkedChildren={t("enabled")}
              unCheckedChildren={t("disabled")}
              loading={item.id === switchLoadding}
              size="small"
              checked={item.status_bank === "Active"}
            />
          ) : (
            <Tag color={tagsBageStatus(item.status_bank)}>
              {t(item.status_bank)}
            </Tag>
          )}
        </span>
      },
    },

    // note
    {
      title: t("note"),
      dataIndex: "note",
      key: "note",
      render: (note) => {
        return (
          <div
            className="text-wrap"
            style={{ fontSize: "11px", width: note ? 150 : 80 }}
          >
            {note ? (
              t(note)
            ) : (
              <em style={{ color: "#888888b4" }}>
                <small>{t("No data")}</small>
              </em>
            )}
          </div>
        );
      },
    },

    // Action 

    {
      title: <span className="text-truncate">{t("Action")}</span>,
      key: "action",
      render: (_, record) => {
        // ดึง Permissions ทั้งหมดออกมา (กันเหนียวด้วย Array.isArray)
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const menuItems = [];

        if (canDetailsBank) {
          menuItems.push({
            key: "Details",
            icon: <EyeOutlined />,
            label: t("Details"),
            onClick: () => showDrawer(record),
          });
        }

        if (canEditBank || canEditAdvancedBank) {
          menuItems.push({
            key: "Edit",
            icon: <FormOutlined />,
            label: t("Edit"),
            onClick: () => handleEditData(record),
          });
        }

        if (canDelBank) {
          menuItems.push({
            key: "Delete",
            icon: <DeleteOutlined />,
            label: t("Delete"),
            danger: true, // Ant Design จะเปลี่ยนเป็นสีแดงให้
            onClick: () => handleDeleteAccounts(record),
          });
        }

        // ถ้าไม่มีสิทธิ์อะไรเลย ไม่ต้องโชว์ปุ่ม Dropdown
        if (menuItems.length === 0) return null;

        return (
          <Space size="middle">
            <div className="md-show">
              <Dropdown
                arrow={true}
                trigger={["click"]}
                placement={dropdownPlacement || "bottomRight"}
                menu={{ items: menuItems }}
              >
                <Button shape="circle">
                  <MoreOutlined style={{ color: "#5A5A5A" }} />
                </Button>
              </Dropdown>
            </div>
          </Space>
        );
      },
    }
  ];

// Repair
export const ColumnsRepair = (
  handleDeleteAccounts,
  showPromiseConfirmStatusBank,
  showDrawer,
  dropdownPlacement,
  tableParams,
  handleEditData,
  selectTypeLoadding,
  currentLanguage,
  resProfileAdmin,
  canDelBank,
  canEditAdvancedBank,
  canEditBank,
  canDetailsBank,
  canChangStatusBank,
) => [

    // #ID
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (id, record, index) => {
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canDetailsBank;

        return <>
          <span
            className={`hover text-center`}
            onClick={() => {
              if (!accessible) {
                alert("!" + t("You don't have permission to view details"));
                return;
              }
              showDrawer(record)
            }}
            title="View details"
            style={{ cursor: "pointer", color: record?.status_bank === "Active" ? "#007bff" : "inherit" }}
          >
            <u>#{id}</u>
          </span>
        </>
      },
    },

    // bank
    {
      title: t("Bank"),

      dataIndex: "bank",
      key: "bank",
      render: (bank) => {
        const imgUrl =
          bank.imageUrl || `https://img2.pic.in.th/pic/noimage4x4.th.jpeg`;
        return (
          <>
            <Space direction="vertical">
              <Avatar size={22} src={imgUrl} />
            </Space>
          </>
        );
      },
    },

    // name
    {
      title: t("Account Name"),

      dataIndex: "accountName",
      key: "accountName",
      render: (accountName) => (
        <span className="text-truncate hover" style={{ maxWidth: "60px", cursor: "copy" }} onClick={() => CopyTextToClipboard(accountName)}>
          {accountName}
        </span>
      ),
    },

    // Account Number
    {
      title: t("Account No."),

      dataIndex: "accountNumber",
      key: "accountNumber",
      render: (accountNumber) => (
        <span style={{ maxWidth: "60px" }} className="text-truncate">
          {accountNumber < 0 ? (
            <em style={{ color: "#888" }}>
              <small>No data</small>
            </em>
          ) : (
            <span style={{ cursor: "copy" }} className="hover" onClick={() => CopyTextToClipboard(accountNumber)}>{accountNumber}</span>
          )}
        </span>
      ),
    },

    // account type
    {
      title: t("account type"),
      dataIndex: "accountType",
      key: "accountType",
      // sorter: (a, b) => a.accountType.length - b.accountType.length,
      sorter: false,

      render: (accountType, record) => {
        return (
          <Space
            className="text-truncate"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <Tag color={tagsTypeBage(accountType)}>{t(accountType)}</Tag>
          </Space>
        );
      },
    },

    // Balance
    {
      title: t("Balance"),
      dataIndex: "balance",
      key: "balance",
      render: (balance) => (
        <code
          style={{
            textTransform: "uppercase",
            color: tagsColorBalance(balance),
          }}
        >
          {balance ? Intl.NumberFormat().format(balance) : "0.00"}
        </code>
      ),
    },

    // Status
    {
      title: t("Status"),
      render: (item) => (
        <span>
          {" "}
          <Tag color={tagsBageStatus(item.status_bank)}>{item.status_bank}</Tag>
        </span>
      ),
    },

    // Issue
    {
      title: t("Issue"),

      render: (item) => <code style={{ color: "#888" }}> {t(item.note)}</code>,
    },

    // Latest update
    {
      title: t("updatedAt"),

      render: (item) => (
        <span> {moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss")}</span>
      ),
    },

    // Action
    {
      title: <span className="text-truncate">{t("Action")}</span>,
      key: "action",
      render: (_, record) => {
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const menuItems = [];

        if (canDetailsBank) {
          menuItems.push({
            key: "Details",
            icon: <EyeOutlined />,
            label: t("Details"),
            onClick: () => showDrawer(record),
          });
        }

        if (canEditBank || canEditAdvancedBank) {
          menuItems.push({
            key: "Edit",
            icon: <FormOutlined />,
            label: t("edit data"),
            onClick: () => handleEditData(record),
          });
        }

        // สมมติว่าปุ่มปัญหาใช้สิทธิ์ 'changeStatus' หรือ 'on_off'
        if (canChangStatusBank) {
          menuItems.push({
            key: "Tool",
            icon: <WarningOutlined />,
            label: <>{t("Ready use")}</>,
            title: t("Account is now ready "),
            onClick: () => showPromiseConfirmStatusBank(record),
          });
        }

        if (canDelBank) {
          menuItems.push({
            key: "Delete",
            icon: <DeleteOutlined />,
            label: t("Delete"),
            danger: true, // Ant Design จะเปลี่ยนเป็นสีแดงให้
            onClick: () => handleDeleteAccounts(record),
          });
        }

        // ถ้าไม่มีสิทธิ์อะไรเลย ไม่ต้องโชว์ปุ่ม Dropdown
        if (menuItems.length === 0) return null;

        return (
          <Space size="middle">
            <div className="md-show">
              <Dropdown
                arrow={true}
                trigger={["click"]}
                placement={dropdownPlacement || "bottomRight"}
                menu={{ items: menuItems }}
              >
                <Button shape="circle">
                  <MoreOutlined style={{ color: "#5A5A5A" }} />
                </Button>
              </Dropdown>
            </div>
          </Space>
        );
      },
    },
  ];

// Suspended
export const ColumnsSuspended = (
  showDrawer,
  tableParams,
  selectTypeLoadding,
  currentLanguage,
  resProfileAdmin,
  canDetailsBank
) => [
    // #ID
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      render: (id, record, index) => {
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canDetailsBank;

        return <>
          <span
            className={`hover text-center`}
            onClick={() => {
              if (!accessible) {
                alert(t("You don't have permission to view details"));
                return;
              }
              showDrawer(record)
            }}
            title="View details"
            style={{ cursor: "pointer", color: record?.status_bank === "Active" ? "#007bff" : "inherit" }}
          >
            <u>#{id}</u>
          </span>
        </>
      },
    },

    // bank
    {
      title: t("Bank"),

      dataIndex: "bank",
      key: "bank",
      render: (bank) => {
        const imgUrl =
          bank.imageUrl || `https://img2.pic.in.th/pic/noimage4x4.th.jpeg`;
        return (
          <>
            <Space direction="vertical">
              <Avatar size={22} src={imgUrl} />
            </Space>
          </>
        );
      },
    },

    // name
    {
      title: t("Account Name"),

      dataIndex: "accountName",
      key: "accountName",
      render: (accountName) => (
        <span onClick={() => CopyTextToClipboard(accountName)} className="text-truncate hover" style={{ maxWidth: "60px", cursor: "copy" }}>
          {accountName}
        </span>
      ),
    },

    // Account Number
    {
      title: t("Account No."),

      dataIndex: "accountNumber",
      key: "accountNumber",
      render: (accountNumber) => (
        <span style={{ maxWidth: "60px" }} className="text-truncate">
          {accountNumber < 0 ? (
            <em style={{ color: "#888" }}>
              <small>No data</small>
            </em>
          ) : (
            <span className="hover" style={{ cursor: "copy" }} onClick={() => CopyTextToClipboard(accountNumber)}>{accountNumber}</span>
          )}
        </span>
      ),
    },

    // account type
    {
      title: t("account type"),
      dataIndex: "accountType",
      key: "accountType",
      // sorter: (a, b) => a.accountType.length - b.accountType.length,
      sorter: false,

      render: (accountType, record) => {
        return (
          <Space
            className="text-truncate"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <Tag color={tagsTypeBage(accountType)}>{t(accountType)}</Tag>
          </Space>
        );
      },
    },

    // Balance
    {
      title: t("Balance"),

      dataIndex: "balance",
      key: "balance",
      render: (balance) => (
        <code
          style={{
            textTransform: "uppercase",
            color: tagsColorBalance(balance),
          }}
        >
          {balance ? Intl.NumberFormat().format(balance) : "0.00"}
        </code>
      ),
    },


    // Status
    {
      title: t("Status"),

      render: (item) => (
        <span>
          {" "}
          <Tag color={tagsBageStatus(item.status_bank)}>{item.status_bank}</Tag>
        </span>
      ),
    },

    // error_code
    {
      title: t("error_code"),

      render: (item) => (
        <code
          style={{
            color: "#cd201f",
            background: "#ffffff",
            padding: "4px",
            borderRadius: "8px",
          }}
        >{`{"${item?.bank?.bank_id}_code":${processPollingStatus(
          item?.logs_banks?.length < 0 ? [] : item?.logs_banks[0],
        ) ||
          item?.status_bank ||
          1
          }}`}</code>
      ),
    },

    // note
    {
      title: t("note"),

      render: (item) => (
        <span
          style={{
            color: "#cd201f",
            background: "#ffffff",
            padding: "4px",
            borderRadius: "8px",
          }}
        >
          {" "}
          {!removeBackslashes(item?.logs_banks?.[0]?.response_headers)
            ? item?.note || (
              <em style={{ color: "#888" }}>
                <small>No data</small>
              </em>
            )
            : removeBackslashes(item?.logs_banks?.[0]?.response_headers)}
        </span>
      ),
    },

    // Created
    {
      title: t("Created At"),

      render: (item) => (
        <span> {moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}</span>
      ),
    },

    // updatedAt
    {
      title: t("updatedAt"),

      render: (item) => (
        <span> {moment(item.updated_at).format("YYYY-MM-DD HH:mm:ss")}</span>
      ),
    },

    // Action
    {
      title: <span className="text-truncate">{t("Action")}</span>,
      key: "action",
      render: (_, record) => {
        // สร้างรายการ Menu Items โดยเช็คสิทธิ์รายอัน
        const accessible = canDetailsBank;

        return (<Space size="middle">
          <div title={t("Details")}>
            {accessible && <Button
              shape="circle"
              type="default"
              size="middle"
              onClick={() => showDrawer(record)}
              icon={<EyeOutlined />}
            />}

          </div>
        </Space>)
      },
    },
  ];
